@if (shouldRender()) {
  <div class="walkthrough">
    <div
      kendoTooltip
      [tooltipTemplate]="tooltipTemplate"
      filter="i"
      style="display: inline"
    >
      <ng-template #tooltipTemplate let-anchor>
        <div>{{ tooltip()?.[0]?.title }}</div>
        <div [innerHTML]="tooltip()?.[0]?.html"></div>
      </ng-template>
      <i class="fas fa-fw fa-lightbulb"></i>
    </div>
  </div>
}
